// import { Iterable } from 'immutable'
import wrappedPropsToJs from '../../functions/wrappedPropsToJs'

const toJS = WrappedComponent => wrappedComponentProps => {
    // const KEY = 0
    // const VALUE = 1

    // const propsJS = Object.entries(
    //     wrappedComponentProps
    // ).reduce((newProps, wrappedComponentProp) => {
    //     newProps[wrappedComponentProp[KEY]] = Iterable.isIterable(
    //         wrappedComponentProp[VALUE]
    //     )
    //         ? wrappedComponentProp[VALUE].toJS()
    //         : wrappedComponentProp[VALUE]

    //     return newProps
    // }, {})

    const propsJS = wrappedPropsToJs(wrappedComponentProps)

    return <WrappedComponent {...propsJS} />
}

export default toJS